import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Input, Col, Row } from 'reactstrap';
import ContentLoader from 'react-content-loader';
import _ from 'lodash'
import api from '../../api';
import './index.css';
import DataObject from '../../components/DataObject';

// The Roster component matches one of two different routes
// depending on the full pathname

const SearchResultListLoader = () => (
    <ContentLoader 
      height={160}
      width={400}
      speed={1}
      primaryColor="#f3f3f3"
      secondaryColor="#ecebeb"
    >
      <rect x="342" y="11" rx="4" ry="4" width="43" height="21" /> 
      <rect x="-7" y="15" rx="3" ry="3" width="200" height="9" /> 
      <rect x="0" y="80" rx="3" ry="3" width="350" height="6" /> 
      <rect x="0" y="100" rx="3" ry="3" width="380" height="6" /> 
      <rect x="-7" y="118" rx="3" ry="3" width="201" height="6" />
    </ContentLoader>
)

  
export default class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchKeyword: '',
            searchResults: [],
            searchResultCount: 0,
            isSearching: false,
            currentUser: null,
        }
        this.search = _.debounce(this.search, 500)
    }
    componentWillMount() {
        this.getCurrentUser();
    }
    componentDidMount = () => {
        document.title = "TCDP";
    }
    setSearchKeyword(value) {
        this.setState({ searchKeyword: value, isSearching: true }, this.search);
    }
    getCurrentUser() {
        api.fetchAPI({
            method: 'get',
            uri: 'user/me',
            success: (response) => {
                console.log(response);
                if (response.status === 'ok') {
                    this.setState({ currentUser: response.user })
                }
            },
            error: (error) => {
              console.error(error);
            }
        });
    }
    search() {
        const { searchKeyword } = this.state;
        this.setState({ isSearching: true, searchResults: [], searchResultCount: 0 });
        api.fetchAPI({
            method: 'get',
            uri: `search?q=${searchKeyword}`,
            success: (response) => {
                this.setState({
                    searchResults: response.results,
                    searchResultCount: response.result_count,
                });
                this.setState({ isSearching: false });
            },
            error: (error) => {
              console.error(error);
              this.setState({ isSearching: false });
            }
        });
    }
    render() {
        const { searchKeyword, searchResultCount, searchResults, isSearching, currentUser } = this.state;
        if (!currentUser) return null;
        return (
            <div style={{ marginTop: 50 }}>
                <Row>
                    <Col xs={12}>
                        <Button tag={Link} to={`/segments`} color="success">Segments</Button>{' '}
                        <Button tag={Link} to={`/analytics/content`} color="info">Advanced Analytics</Button>{' '}
                        <Button tag={Link} to={`/ai/content_edit`} color="info">AI Content Monitor</Button>{' '}
                    </Col>
                </Row>
                <br />
                {/* <Button tag={Link} to={``} color="success">Point entry</Button>{' '}
                <Button tag={Link} to='/me/change-password' color="secondary">Đổi mật khẩu</Button>{' '} */}
                <Row>
                    <Col xs={12}>
                        <input
                            className="search-box"
                            type="text"
                            placeholder="Search for datasources, database, tables, fields... Try: total_amount"
                            onChange={(e) => this.setSearchKeyword(e.target.value)}
                        />
                        {searchKeyword &&
                            <div className="home-search-result-container">
                                {!isSearching && searchResultCount > 0 &&
                                    <p>Found {searchResultCount} result(s) for keyword "{searchKeyword}"</p>
                                }
                                {isSearching &&
                                    <p>Searching for results. Please wait...</p>
                                }
                                {isSearching &&
                                    [1, 2, 3].map(key => <SearchResultListLoader key={key} />)
                                }
                            </div>
                        }
                    </Col>
                    <Col xs={12}>
                        <br />
                        <Button tag={Link} to="/content_types" color="primary">Content Types Setting</Button>
                        {currentUser.is_system_admin === 1 ?
                            <Button tag={Link} to="/users" color="primary">User Management</Button>
                            :
                            null
                        }{' '}
                        <Button tag={Link} to={`/datasources`} color="primary">Datasources</Button>{' '}
                        <Button tag={Link} to={`/dashboards`} color="primary">Dashboards</Button>{' '}
                        <a
                            href="https://console.firebase.google.com/u/0/project/tinhte-apps/overview"
                            target="_blank"
                        >
                            Firebase
                        </a>
                    </Col>
                </Row>
                <Row>
                    {searchResults && searchResults.map(result =>
                        <Col xs={12}  className="home-search-result-item" key={`${result.object_type}_${result.id}`}>
                            <DataObject dataObject={result} />
                        </Col>
                    )}
                </Row>
            </div>
        )
    };
}



// WEBPACK FOOTER //
// ./src/pages/Home/index.js